<template>
  <div
    v-on:click="
      getAllPosts();
      scrollTop();
    "
  >
    <h3><strong>More BelAmi Webcams</strong></h3>
    <div class="archive-grid">
      <router-link
        v-for="video in videos"
        :key="video.id"
        :to="{ name: 'belami-cams-video', params: { id: video.id } }"
      >
        <img
          :src="
            'https://freecdn.belamionline.com/Data/Models/Model_' +
            video.id +
            '/ChatImage.jpg'
          "
          :alt="video.title"
          @click="tracking(video.id)"
        />
        <p @click="tracking(video.id)">{{ video.name }}</p>
      </router-link>
    </div>
    <br />
  </div>
</template>

<script>
import vids from "@/belcams.json";
export default {
  data() {
    return {
      videos: [],
    };
  },
  created() {
    this.getAllPosts();
  },
  methods: {
    getAllPosts() {
      const videoList = JSON.parse(JSON.stringify(vids));
      const shuffledVids = videoList.sort(() => 0.5 - Math.random());
      this.videos = shuffledVids.slice(0, 8);
      window.scrollTo(0, 0);
    },
    scrollTop() {
      window.scrollTo(0, 100);
    },
    tracking(id) {
      this.$ga.page("/tube/belami-cams/video/" + id);
    },
  },
};
</script>